import * as React from 'react';
import DOMPurify from 'isomorphic-dompurify';

import * as styles from './TabView.css';

type TabViewProps = {
  description: string | undefined | null;
  imageUrl: string;
};

export const TabView: React.FC<TabViewProps> = ({ description, imageUrl }) => {
  // Описание в виде HTML должно поддерживаться для кастомизации с админки, вставлять ссылки и т.д.
  // Но в то же время нужно избегать XSS атак, поэтому используем sanitize
  const sanitizedDescription = React.useMemo(() => description && DOMPurify.sanitize(description), [description]);

  return (
    <div className={styles['container']}>
      <img data-testid="tab-image" src={imageUrl} className={styles['image']} />

      {!!sanitizedDescription && (
        <div
          data-testid="tab-description"
          className={styles['description']}
          // oxlint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
        />
      )}
    </div>
  );
};
